/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Goodforcount2Inputs */

const en_goodforcount2 = /** @type {(inputs: Goodforcount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of ${i?.max}`)
};

const de_goodforcount2 = /** @type {(inputs: Goodforcount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} von ${i?.max}`)
};

/**
* | output |
* | --- |
* | "{count} of {max}" |
*
* @param {Goodforcount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforcount2 = /** @type {((inputs: Goodforcount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforcount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforcount2(inputs)
	return de_goodforcount2(inputs)
});
export { goodforcount2 as "goodForCount" }